var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g2, _path20, _path21, _g3, _g4, _g5, _g6, _g7, _path22, _path23, _path24, _g8, _g9, _g10, _g11, _path25, _path26, _path27, _g12, _g13, _g14, _g15, _path28, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgSpace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1115,
    height: 784,
    viewBox: "0 0 1115 784",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1115,
    height: 784,
    fill: "#9F35CA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M266.46 675.11C274.082 675.11 280.26 668.932 280.26 661.31C280.26 653.688 274.082 647.51 266.46 647.51C258.838 647.51 252.66 653.688 252.66 661.31C252.66 668.932 258.838 675.11 266.46 675.11Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M266.46 674.49C273.739 674.49 279.64 668.589 279.64 661.31C279.64 654.031 273.739 648.13 266.46 648.13C259.181 648.13 253.28 654.031 253.28 661.31C253.28 668.589 259.181 674.49 266.46 674.49Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.11 397.24C194.927 397.24 197.21 394.957 197.21 392.14C197.21 389.323 194.927 387.04 192.11 387.04C189.293 387.04 187.01 389.323 187.01 392.14C187.01 394.957 189.293 397.24 192.11 397.24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M556.11 693.24C558.927 693.24 561.21 690.957 561.21 688.14C561.21 685.323 558.927 683.04 556.11 683.04C553.293 683.04 551.01 685.323 551.01 688.14C551.01 690.957 553.293 693.24 556.11 693.24Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M341.11 716.99C342.684 716.99 343.96 715.714 343.96 714.14C343.96 712.566 342.684 711.29 341.11 711.29C339.536 711.29 338.26 712.566 338.26 714.14C338.26 715.714 339.536 716.99 341.11 716.99Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M972.11 578.99C973.684 578.99 974.96 577.714 974.96 576.14C974.96 574.566 973.684 573.29 972.11 573.29C970.536 573.29 969.26 574.566 969.26 576.14C969.26 577.714 970.536 578.99 972.11 578.99Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M809.11 322.99C810.684 322.99 811.96 321.714 811.96 320.14C811.96 318.566 810.684 317.29 809.11 317.29C807.536 317.29 806.26 318.566 806.26 320.14C806.26 321.714 807.536 322.99 809.11 322.99Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.11 447.99C1041.68 447.99 1042.96 446.714 1042.96 445.14C1042.96 443.566 1041.68 442.29 1040.11 442.29C1038.54 442.29 1037.26 443.566 1037.26 445.14C1037.26 446.714 1038.54 447.99 1040.11 447.99Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M282.11 230.24C284.927 230.24 287.21 227.957 287.21 225.14C287.21 222.323 284.927 220.04 282.11 220.04C279.293 220.04 277.01 222.323 277.01 225.14C277.01 227.957 279.293 230.24 282.11 230.24Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.94 570.21H137.4V565.67H135.55V570.21H131.01V572.06H135.55V576.59H137.4V572.06H141.94V570.21Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M255.94 568.21H251.4V563.67H249.55V568.21H245.01V570.06H249.55V574.59H251.4V570.06H255.94V568.21Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M418.94 660.21H414.4V655.67H412.55V660.21H408.01V662.06H412.55V666.59H414.4V662.06H418.94V660.21Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M645.97 108.71H643.9V106.64H643.06V108.71H640.99V109.55H643.06V111.62H643.9V109.55H645.97V108.71Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M940.97 298.71H938.9V296.64H938.06V298.71H935.99V299.55H938.06V301.62H938.9V299.55H940.97V298.71Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M766.97 422.71H764.9V420.64H764.06V422.71H761.99V423.55H764.06V425.62H764.9V423.55H766.97V422.71Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.97 500.71H56.9V498.64H56.06V500.71H53.99V501.55H56.06V503.62H56.9V501.55H58.97V500.71Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M143.97 670.71H141.9V668.64H141.06V670.71H138.99V671.55H141.06V673.62H141.9V671.55H143.97V670.71Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M410.97 133.71H408.9V131.64H408.06V133.71H405.99V134.55H408.06V136.62H408.9V134.55H410.97V133.71Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.97 432.71H282.9V430.64H282.06V432.71H279.99V433.55H282.06V435.62H282.9V433.55H284.97V432.71Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M311.97 346.71H309.9V344.64H309.06V346.71H306.99V347.55H309.06V349.62H309.9V347.55H311.97V346.71Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M737.15 545.17C743.512 545.17 748.67 540.012 748.67 533.65C748.67 527.288 743.512 522.13 737.15 522.13C730.788 522.13 725.63 527.288 725.63 533.65C725.63 540.012 730.788 545.17 737.15 545.17Z",
    fill: "url(#paint1_linear)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M737.15 544.32C743.043 544.32 747.82 539.543 747.82 533.65C747.82 527.757 743.043 522.98 737.15 522.98C731.257 522.98 726.48 527.757 726.48 533.65C726.48 539.543 731.257 544.32 737.15 544.32Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M765.88 620.69C772.469 620.69 777.81 615.349 777.81 608.76C777.81 602.171 772.469 596.83 765.88 596.83C759.291 596.83 753.95 602.171 753.95 608.76C753.95 615.349 759.291 620.69 765.88 620.69Z",
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M404.73 545.88H422.34L421.16 537.83H405.91L404.73 545.88Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M608.08 545.88H625.7L624.52 537.83H609.26L608.08 545.88Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M481.83 545.88H499.45L498.27 537.83H483.01L481.83 545.88Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M530.13 545.88H547.75L546.56 537.83H531.31L530.13 545.88Z",
    fill: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M565.39 136.35H459.48V140.46H565.39V136.35Z",
    fill: "black"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M750.04 289.33C747.263 285.683 743.789 282.624 739.82 280.33V280.33C735.26 277.7 730.156 276.155 724.903 275.813C719.65 275.47 714.389 276.341 709.526 278.357C704.663 280.372 700.329 283.479 696.858 287.437C693.388 291.396 690.874 296.099 689.511 301.184C688.149 306.268 687.974 311.598 689 316.761C690.026 321.924 692.225 326.783 695.429 330.96C698.632 335.137 702.753 338.522 707.473 340.852C712.193 343.183 717.386 344.397 722.65 344.4C723.38 344.4 724.11 344.4 724.82 344.32C731.007 343.93 736.972 341.871 742.083 338.362C747.194 334.854 751.259 330.026 753.846 324.393C756.434 318.76 757.447 312.531 756.779 306.368C756.11 300.205 753.785 294.338 750.05 289.39L750.04 289.33Z",
    fill: "url(#paint2_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M755.09 310.01C755.089 318.26 751.945 326.201 746.298 332.216C740.65 338.231 732.924 341.869 724.69 342.39C724.02 342.39 723.33 342.46 722.64 342.46C717.659 342.463 712.745 341.32 708.277 339.119C703.809 336.918 699.907 333.718 696.874 329.767C693.841 325.817 691.757 321.221 690.785 316.336C689.813 311.451 689.978 306.408 691.267 301.597C692.556 296.786 694.936 292.337 698.22 288.593C701.505 284.849 705.607 281.911 710.21 280.006C714.812 278.102 719.791 277.282 724.761 277.611C729.731 277.939 734.558 279.407 738.87 281.9V281.9C742.629 284.081 745.913 286.991 748.53 290.46V290.46C752.794 296.085 755.098 302.952 755.09 310.01Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M714.65 289.42C712.972 290.142 711.354 290.995 709.81 291.97C708.779 292.533 707.893 293.327 707.22 294.29C706.886 294.775 706.703 295.347 706.692 295.936C706.681 296.525 706.844 297.103 707.16 297.6C707.95 298.68 709.47 298.84 710.81 298.92C712.217 299.099 713.647 298.956 714.99 298.5C715.897 298.051 716.722 297.453 717.43 296.73L720.22 294.2C721.22 293.32 722.22 292.11 721.83 290.87C721.599 290.427 721.262 290.049 720.848 289.769C720.434 289.49 719.957 289.318 719.46 289.27C717.055 288.801 714.561 289.24 712.46 290.5",
    fill: "black"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M703 324.53C703.944 324.53 704.71 323.764 704.71 322.82C704.71 321.876 703.944 321.11 703 321.11C702.056 321.11 701.29 321.876 701.29 322.82C701.29 323.764 702.056 324.53 703 324.53Z",
    fill: "black"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M737.72 318.26C741.177 318.26 743.98 315.457 743.98 312C743.98 308.543 741.177 305.74 737.72 305.74C734.263 305.74 731.46 308.543 731.46 312C731.46 315.457 734.263 318.26 737.72 318.26Z",
    fill: "black"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M748.59 290.46C748.572 292.097 748.084 293.694 747.184 295.061C746.284 296.428 745.01 297.507 743.514 298.171C742.017 298.835 740.362 299.055 738.745 298.804C737.127 298.554 735.616 297.844 734.39 296.759C733.164 295.674 732.276 294.26 731.832 292.685C731.387 291.11 731.404 289.44 731.882 287.874C732.359 286.309 733.276 284.913 734.524 283.854C735.772 282.795 737.298 282.117 738.92 281.9V281.9C742.682 284.08 745.97 286.99 748.59 290.46Z",
    fill: "black"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M749.17 328.69C746.379 332.664 742.729 335.958 738.491 338.33C734.254 340.701 729.537 342.089 724.69 342.39C724.69 341.94 724.63 341.49 724.63 341.03C724.633 338.182 725.426 335.391 726.922 332.968C728.417 330.544 730.556 328.583 733.101 327.304C735.645 326.025 738.494 325.477 741.332 325.722C744.169 325.966 746.882 326.994 749.17 328.69V328.69Z",
    fill: "black"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M306.76 474.58C304.824 472.02 302.396 469.871 299.62 468.26V468.26C296.433 466.391 292.858 465.282 289.173 465.021C285.488 464.759 281.792 465.352 278.374 466.753C274.955 468.154 271.906 470.326 269.464 473.098C267.023 475.871 265.254 479.17 264.296 482.738C263.338 486.306 263.217 490.047 263.942 493.67C264.667 497.292 266.218 500.699 268.476 503.624C270.733 506.548 273.635 508.912 276.955 510.532C280.276 512.151 283.926 512.982 287.62 512.96C288.13 512.96 288.62 512.96 289.14 512.91C293.449 512.62 297.599 511.173 301.154 508.721C304.709 506.269 307.537 502.903 309.339 498.979C311.141 495.054 311.851 490.716 311.393 486.422C310.936 482.128 309.328 478.037 306.74 474.58H306.76Z",
    fill: "url(#paint3_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.28 489.01C310.279 494.766 308.085 500.306 304.145 504.502C300.205 508.698 294.815 511.236 289.07 511.6C288.6 511.6 288.07 511.6 287.64 511.6C284.168 511.599 280.742 510.8 277.628 509.263C274.515 507.727 271.796 505.495 269.682 502.74C267.569 499.985 266.118 496.781 265.44 493.376C264.763 489.97 264.878 486.455 265.777 483.101C266.675 479.747 268.333 476.645 270.623 474.034C272.912 471.423 275.771 469.374 278.978 468.045C282.186 466.715 285.657 466.142 289.121 466.368C292.586 466.595 295.952 467.615 298.96 469.35V469.35C301.586 470.878 303.878 472.919 305.7 475.35C308.681 479.279 310.29 484.078 310.28 489.01V489.01Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M282.06 474.65C280.891 475.148 279.764 475.74 278.69 476.42C277.974 476.819 277.356 477.373 276.88 478.04C276.658 478.384 276.54 478.785 276.54 479.195C276.54 479.605 276.658 480.006 276.88 480.35C277.212 480.678 277.611 480.929 278.049 481.088C278.488 481.247 278.955 481.309 279.42 481.27C280.403 481.397 281.401 481.298 282.34 480.98C282.976 480.666 283.554 480.247 284.05 479.74L285.99 477.98C286.67 477.36 287.41 476.52 287.11 475.66C286.957 475.345 286.724 475.076 286.435 474.88C286.145 474.683 285.809 474.566 285.46 474.54C283.786 474.212 282.05 474.519 280.59 475.4",
    fill: "black"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M273.93 499.13C274.587 499.13 275.12 498.597 275.12 497.94C275.12 497.283 274.587 496.75 273.93 496.75C273.273 496.75 272.74 497.283 272.74 497.94C272.74 498.597 273.273 499.13 273.93 499.13Z",
    fill: "black"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M298.16 494.77C300.574 494.77 302.53 492.814 302.53 490.4C302.53 487.987 300.574 486.03 298.16 486.03C295.747 486.03 293.79 487.987 293.79 490.4C293.79 492.814 295.747 494.77 298.16 494.77Z",
    fill: "black"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M305.71 475.37C305.701 476.523 305.36 477.648 304.728 478.612C304.096 479.576 303.2 480.338 302.147 480.806C301.093 481.274 299.927 481.429 298.788 481.252C297.649 481.075 296.586 480.573 295.724 479.807C294.862 479.042 294.24 478.044 293.93 476.933C293.621 475.823 293.638 474.647 293.979 473.546C294.321 472.445 294.972 471.466 295.855 470.725C296.738 469.985 297.816 469.514 298.96 469.37C301.59 470.897 303.885 472.938 305.71 475.37V475.37Z",
    fill: "black"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M306.15 502.04C304.202 504.812 301.656 507.111 298.699 508.766C295.743 510.421 292.452 511.389 289.07 511.6C289.07 511.29 289.07 510.97 289.07 510.6C289.072 508.613 289.625 506.666 290.668 504.975C291.712 503.284 293.204 501.916 294.979 501.024C296.754 500.131 298.742 499.749 300.721 499.919C302.701 500.09 304.594 500.807 306.19 501.99L306.15 502.04Z",
    fill: "black"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M943.9 408.07C944.916 408.07 945.74 407.246 945.74 406.23C945.74 405.214 944.916 404.39 943.9 404.39C942.884 404.39 942.06 405.214 942.06 406.23C942.06 407.246 942.884 408.07 943.9 408.07Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 266.46,
    y1: 675.11,
    x2: 266.46,
    y2: 647.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 17963,
    y1: 13589.5,
    x2: 17963,
    y2: 13058.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 53268.2,
    y1: 28373.5,
    x2: 53268.2,
    y2: 23659.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 16171.4,
    y1: 28201.7,
    x2: 16171.4,
    y2: 25902.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSpace);
export default __webpack_public_path__ + "static/media/bg-space.986b9e80016468a9addd5c274ca1a651.svg";
export { ForwardRef as ReactComponent };